import { School } from "./school";

export class Student {
    id: string;
    firstName: string;
    lastName: string;
    surName: string;
    fullName: string;
    school: School;
    birthday: Date;
    number: string;
}